import { render, staticRenderFns } from "./leftCol_Desktop.vue?vue&type=template&id=29f35476"
import script from "./leftCol_Desktop.vue?vue&type=script&lang=js"
export * from "./leftCol_Desktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports